import { render, staticRenderFns } from "./DialogCadastrarCategoria.vue?vue&type=template&id=f7b5e3b2"
import script from "./DialogCadastrarCategoria.vue?vue&type=script&lang=js"
export * from "./DialogCadastrarCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports